export default "/images/icon_key_primary.svg?be234404eeee9a4db01d8d49e710f4e4";